'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIntersectionObserver } from '@/app/hooks/useIntersectionObserver';

const Testimonials: React.FC = () => {
  const { t } = useTranslation();
  const { ref, isVisible } = useIntersectionObserver();

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container">
        <div ref={ref} className={`text-center mb-16 fade-in-section ${isVisible ? 'is-visible' : ''}`}>
          <div className="inline-block bg-primary-50 rounded-full px-6 py-2 text-primary-600 font-medium text-sm mb-4 animate-pulse-shadow">
            {t('pageContent.home.testimonials.tagline')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('pageContent.home.testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('pageContent.home.testimonials.subtitle')}
          </p>
        </div>

        
        <div className={`mt-16 bg-white p-8 md:p-12 rounded-xl shadow-sm border border-gray-100 hover-lift fade-in-section ${isVisible ? 'is-visible' : ''}`} style={{ transitionDelay: '0.4s' }}>
          {/* Single column, not a 2-col grid. The right-hand cell used to hold a
              "98% of founders would recommend" figure and a hardcoded five-star
              rating; both were removed as unsourced, which left a grid with one
              child rendering as a visibly empty half-card. */}
          <div className="max-w-3xl">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('pageContent.home.testimonials.cta.title')}
              </h3>
              <p className="text-gray-600 mb-6">
                {t('pageContent.home.testimonials.cta.description')}
              </p>
              <div className="flex flex-wrap gap-4">
                {(() => {
                  const tags = t('pageContent.home.testimonials.tags', { returnObjects: true });
                  return (Array.isArray(tags) ? tags : []).map((tag: string, index: number) => (
                    <div
                      key={index}
                      className={`bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm hover-scale fade-in-section ${isVisible ? 'is-visible' : ''}`}
                      style={{ transitionDelay: `${0.6 + index * 0.1}s` }}
                    >
                      {tag}
                    </div>
                  ));
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Testimonials };
